module.exports = __webpack_public_path__ + "img/mountain.5394e7f1.jpg";